export const actionTypes = {
  SET_JOB: '[Jobs] Set Job',
  CLEAR_JOB: '[Jobs] Clear Job',
}

export const actions = {
  setJob: (key, job) => ({
    type: actionTypes.SET_JOB,
    payload: { key, job },
  }),
  clearJob: (key) => ({
    type: actionTypes.CLEAR_JOB,
    payload: { key },
  }),
}
